import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Message from "../components/Message";
import Loader from "../components/Loader";
import { listProductDetails, updateProduct } from "../actions/productActions";
import FormContainer from "../components/FormContainer";
import { PRODUCT_UPDATE_RESET } from "../constants/productConstants";

// Import form components
import EyeglassForm from "../components/ProductForms/EyeglassForm";
import SunglassForm from "../components/ProductForms/SunglassForm";
import ContactlensForm from "../components/ProductForms/ContactlensForm";
import FramelensForm from "../components/ProductForms/FramelensForm";
import BrandForm from "../components/ProductForms/BrandForm";
import AccessoriesForm from "../components/ProductForms/AccessoriesForm";
import CategoryDrawer from "../components/ProductForms/CategoryDrawer";

const ProductAddScreen2 = ({ match, history }) => {
  const productId = match.params.id;
  const [showDrawer, setShowDrawer] = useState(true);
  const [selectedType, setSelectedType] = useState("");
  const [accessoryType, setAccessoryType] = useState("");
  const [disable, setDisable] = useState(false);
  const [productData, setProductData] = useState({
    name: "",
    price: 0,
    image: "",
    brand: "",
    category: "",
    countInStock: 0,
    description: "",
    gender: "",
    shape: "",
    usage: "",
    colour: "",
    solutionQuantity: "",
    offersIds: [],
    frameIds: [],
    ProductPriority: "1",
  });
  console.log("Initial productData state:", productData);

  const [uploading, setUploading] = useState(false);

  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.userLogin);

  const productDetails = useSelector((state) => state.productDetails);
  const { loading, error, product } = productDetails;

  const productUpdate = useSelector((state) => state.productUpdate);
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = productUpdate;

  useEffect(() => {
    if (successUpdate) {
      dispatch({ type: PRODUCT_UPDATE_RESET });
      history.push("/admin/productlist");
    }
  }, [dispatch, history, successUpdate]);

  useEffect(() => {
    if (!product.name || product._id !== productId) {
      dispatch(listProductDetails(productId));
    } else {
      setProductData({
        name: product.name || "",
        price: product.price || 0,
        image: product.image || "",
        brand: product.brand || "",
        gender: product.gender || "",
        colour: product.colour || "",
        shape: product.shape || "",
        usage: product.usage || "",
        category: product.category || "",
        countInStock: product.countInStock || 0,
        description: product.description || "",
        frameIds: product.frameIds || [],
        offersIds: product.OffersIds || [],
        // ProductPriority: product.ProductPriority || "1",
      });
    }
  }, [dispatch, product, productId, history]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setProductData({
      ...productData,
      [id]: value,
    });
  };

  const handleFormattedChange = (e) => {
    const { id, value } = e.target;
    setProductData({
      ...productData,
      [id]: formatValue(value),
    });
  };

  const formatValue = (value) => {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisable(false);
    // Set category based on selectedType and accessoryType
    let finalCategory = selectedType;
    if (selectedType === "Accessories") {
      finalCategory = accessoryType;
    }
    if (selectedType === "BrandsImage") {
      finalCategory = productData.category;
    }

    if (window.confirm("Are you sure?")) {
      console.log("product data", productData);
      console.log("finale", finalCategory);
      dispatch(
        updateProduct({
          _id: productId,
          ...productData,
          category: finalCategory,
        })
      );
    }
    // history.push("/admin/productlist");
    // window.location.reload();
  };

  const renderForm = () => {
    switch (selectedType) {
      case "Eyeglasses":
        return (
          <EyeglassForm
            productData={productData}
            setProductData={setProductData}
            handleInputChange={handleInputChange}
            handleFormattedChange={handleFormattedChange}
            uploading={uploading}
            setUploading={setUploading}
            userInfo={userInfo}
            onSubmit={handleSubmit}
          />
        );
      case "Sunglasses":
        return (
          <SunglassForm
            productData={productData}
            setProductData={setProductData}
            handleInputChange={handleInputChange}
            handleFormattedChange={handleFormattedChange}
            uploading={uploading}
            setUploading={setUploading}
            userInfo={userInfo}
            onSubmit={handleSubmit}
          />
        );
      case "Contactlens":
        return (
          <ContactlensForm
            productData={productData}
            setProductData={setProductData}
            handleInputChange={handleInputChange}
            handleFormattedChange={handleFormattedChange}
            uploading={uploading}
            setUploading={setUploading}
            userInfo={userInfo}
            onSubmit={handleSubmit}
          />
        );
      case "Framelens":
        return (
          <FramelensForm
            productData={productData}
            setProductData={setProductData}
            handleInputChange={handleInputChange}
            handleFormattedChange={handleFormattedChange}
            uploading={uploading}
            setUploading={setUploading}
            userInfo={userInfo}
            onSubmit={handleSubmit}
            setDisable={setDisable}
            disable={disable}
          />
        );
      case "BrandsImage":
        return (
          <BrandForm
            productData={productData}
            setProductData={setProductData}
            handleInputChange={handleInputChange}
            handleFormattedChange={handleFormattedChange}
            uploading={uploading}
            setUploading={setUploading}
            userInfo={userInfo}
            onSubmit={handleSubmit}
          />
        );
      case "Accessories":
        return (
          <AccessoriesForm
            productData={productData}
            setProductData={setProductData}
            handleInputChange={handleInputChange}
            handleFormattedChange={handleFormattedChange}
            uploading={uploading}
            setUploading={setUploading}
            userInfo={userInfo}
            accessoryType={accessoryType}
            setAccessoryType={setAccessoryType}
            onSubmit={handleSubmit}
          />
        );
      default:
        return (
          <div className='text-center' style={{ alignContent: "start" }}>
            <h5>Please select a product category from the drawer</h5>
            <Button
              variant='primary'
              className='mt-3'
              onClick={() => setShowDrawer(true)}
            >
              Open Category Selection
            </Button>
          </div>
        );
    }
  };

  return (
    <>
      <Row className='mt-5'>
        <Col md={8} style={{ marginTop: "1rem", justifyContent: "start" }}>
          <h1>Add Product in Clearspecs</h1>
        </Col>
        <Col className='text-end' md={4}>
          <Link
            to='/admin/productlist'
            className='btn btn-light'
            style={{
              marginTop: "2rem",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            Go Back
          </Link>
        </Col>
      </Row>

      <Row className='flex'>
        <Col md={3}>
          <CategoryDrawer
            show={showDrawer}
            onHide={() => setShowDrawer(false)}
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            accessoryType={accessoryType}
            setAccessoryType={setAccessoryType}
          />

          {/* Button to re-open drawer if closed */}
          {!showDrawer && (
            <Button
              variant='outline-primary'
              className='w-100 mb-3'
              onClick={() => setShowDrawer(true)}
            >
              Change Product Category
            </Button>
          )}
        </Col>

        <Col md={9}>
          <FormContainer>
            {loadingUpdate && <Loader />}
            {errorUpdate && <Message variant='danger'>{errorUpdate}</Message>}
            {loading ? (
              <Loader />
            ) : error ? (
              <Message variant='danger'>{error}</Message>
            ) : (
              renderForm()
            )}
          </FormContainer>
        </Col>
      </Row>
    </>
  );
};

export default ProductAddScreen2;
